<template>
  <TSpinner v-if="loading" name="ai-analysis" :partial-page="true" />

  <span v-if="inputs" class="font-bold text-lg"
    >Asking: {{ inputs.query }}</span
  >
  <div v-if="error" class="mt-4 text-nash-midnightBlue700 align-middle">
    <div class="italic">
      Sorry, there was an error fetching a response. Please try again with a
      different query.
    </div>
  </div>
  <div
    v-else-if="!!responseText"
    class="mt-4 text-nash-midnightBlue700 align-middle"
  >
    <TMarkdown :source="responseText" />
    <hr class="my-2 h-px" />
    <div class="font-bold">For more information, see:</div>
    <ul v-if="!!sources.length" class="list-inside list-disc">
      <li v-for="source in sources" :key="source.documentName">
        <router-link
          v-if="showLink(source) && source.documentId"
          :to="{
            name: '#sopLibraryDocument',
            params: {
              documentId: source.documentId,
            },
            query: {
              search: source.relevantContent,
            },
          }"
          target="_blank"
        >
          {{ source.documentName }}
        </router-link>
        <span v-else>{{ source.documentName }}</span>
      </li>
    </ul>
    <span v-else>Could not locate documents with more information.</span>
    <div class="mt-1">
      <TMTertiaryButton
        label="Clear Response"
        icon="reset"
        :justify-between="true"
        @click="reset"
      />
    </div>
    <hr class="my-2 h-px" />
    <LlmFeedback
      v-if="!loading && loggingDetails"
      :raw-log-id="loggingDetails.rawLogId"
      :datadog-logging-details="loggingDetails"
      :extra-feedback-reasons="EXTRA_FEEDBACK_REASONS"
    />
  </div>
</template>

<script lang="ts">
import TMTertiaryButton from '@nashville/button/TMTertiaryButton.vue'
import TSpinner from '@thyme/nashville/src/components/spinner/TSpinner.vue'
import { defineComponent } from 'vue'
import TMarkdown from '@/legacy/nashville/text/TMarkdown.vue'
import LlmFeedback from '@/tokens/llm/LlmFeedback/LlmFeedback.vue'
import setup from './controller'
import { ASK_SOP_RESPONSE_PROPS } from './types'

export default defineComponent({
  components: {
    TMTertiaryButton,
    TSpinner,
    TMarkdown,
    LlmFeedback,
  },
  props: ASK_SOP_RESPONSE_PROPS,
  emits: ['reset'],
  setup,
})
</script>
